// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page-specific styles for Home */

/* Home */
.home-hero {
  position: relative;
  overflow: hidden;
  padding: 0.8rem 0;
  color: white;
  background: var(--green-950);
}
.home-hero::before {
  content: "";
  position: absolute;
  width: 380px;
  height: 380px;
  left: -240px;
  bottom: -180px;
  border: 70px solid rgba(255, 255, 255, 0.04);
  border-radius: 50%;
}
.mobile-location {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 2.5rem;
  font-size: 0.8rem;
}
.mobile-location span {
  flex: 1;
}
.mobile-location small,
.mobile-location strong {
  display: block;
  line-height: 1.25;
  font-size: 14px;
}
.mobile-location small {
  color: rgba(255, 255, 255, 0.5);
}
.hero-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.2rem;
  padding: 0.55rem 0.8rem;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50px;
  color: #dcebe2;
  background: rgba(255, 255, 255, 0.06);
  font-size: 0.75rem;
  font-weight: 700;
}
.home-hero h2 {
  font-size: clamp(3.1rem, 8vw, 6rem);
  line-height: 0.9;
  margin: 0;
}
.home-hero h2 em {
  color: var(--yellow);
  font-weight: inherit;
}
.home-hero .col-lg-6 > p {
  color: rgba(255, 255, 255, 0.68);
  font-size: 1.1rem;
  max-width: 560px;
  margin: 1.5rem 0;
}
.hero-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.trust-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1.25rem;
  color: rgba(255, 255, 255, 0.66);
  font-size: 0.78rem;
}
.trust-row i {
  color: #82c89c;
}
.hero-visual {
  display: none;
  position: relative;
  max-width: 520px;
  margin-left: auto;
}
.hero-visual > img {
  width: 100%;
  height: 550px;
  object-fit: cover;
  border-radius: 42% 42% 26px 26px;
}
.floating-card {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 220px;
  padding: 0.9rem 1rem;
  border-radius: 16px;
  color: var(--ink);
  background: rgba(255, 254, 250, 0.94);
  box-shadow: var(--shadow);
  backdrop-filter: blur(12px);
}
.floating-card.top {
  top: 22%;
  left: -14%;
}
.floating-card.bottom {
  right: -5%;
  bottom: 9%;
}
.floating-card > i {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: var(--green-800);
  background: var(--green-100);
}
.floating-card small,
.floating-card strong {
  display: block;
  font-size: 0.72rem;
  line-height: 1.3;
}
.floating-card small {
  color: var(--muted);
}
.service-card {
  height: 100%;
  min-height: 300px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1.25fr 0.75fr;
  border-radius: var(--radius);
  color: white;
  text-decoration: none;
  position: relative;
}
.service-card.shake {
  background: #376c54;
}
.service-card.fruits {
  background: #b85534;
}
.service-card > div {
  z-index: 1;
  padding: 1.7rem;
  align-self: center;
}
.service-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  mask-image: linear-gradient(to right, transparent, black 32%);
}
.service-card h2,
.service-card h3 {
  margin: 0.5rem 0;
  font-family: var(--font-serif);
  font-size: clamp(1.6rem, 3vw, 2.4rem);
  line-height: 1;
}
.service-card p {
  color: rgba(255, 255, 255, 0.75);
}
.service-card .card-kicker {
  color: rgba(255, 255, 255, 0.6);
}
.service-icon {
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  border-radius: 14px;
  color: var(--green-950);
  background: var(--yellow);
  font-size: 1.15rem;
}
.service-link {
  font-size: 1.2rem;
  font-weight: 800;
}
.service-link i {
  margin-left: 0.35rem;
  transition: transform 0.2s;
}
.service-card:hover .service-link i {
  transform: translateX(4px);
}
.next-delivery {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.25rem;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
  box-shadow: 0 8px 30px rgba(23, 49, 36, 0.05);
}
.date-tile {
  width: 65px;
  height: 72px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  color: white;
  background: var(--green-800);
}
.date-tile strong {
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 1;
}
.date-tile span {
  font-size: 0.65rem;
  letter-spacing: 0.12em;
}
.next-delivery h3 {
  font-family: var(--font-serif);
  margin: 0 0 0.35rem;
  font-size: 1.5rem;
}
.next-delivery p {
  margin: 0;
  color: var(--muted);
  font-size: 0.9rem;
}
.how-section {
  padding: 2rem 0;
  background: #edf3ee;
}
.steps-grid {
  display: grid;
  gap: 1rem;
}
.step-card {
  position: relative;
  min-height: 245px;
  padding: 1.5rem;
  border: 1px solid #d7e4da;
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.55);
}
.step-card > i {
  width: 50px;
  height: 50px;
  display: grid;
  place-items: center;
  border-radius: 15px;
  color: var(--green-700);
  background: white;
}
.step-number {
  position: absolute;
  right: 1.4rem;
  top: 1.1rem;
  font-family: var(--font-serif);
  color: #b6cabd;
  font-size: 2.2rem;
}
.step-card h3 {
  margin-top: 2rem;
  font-family: var(--font-serif);
  font-size: 1.5rem;
}
.step-card p {
  color: var(--muted);
}
.freshness-banner {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  padding: 1.25rem;
  border-radius: var(--radius);
  color: white;
  background: var(--green-950);
}
.freshness-banner > i {
  color: var(--yellow);
  font-size: 1.4rem;
}
.freshness-banner p {
  margin: 0.25rem 0 0;
  color: rgba(255, 255, 255, 0.65);
}
.benefit-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}
.benefit-grid div {
  min-height: 120px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid var(--line);
  border-radius: 18px;
  background: var(--paper);
  font-weight: 700;
}
.benefit-grid i {
  color: var(--green-700);
  font-size: 1.3rem;
}

@media (min-width: 576px) {
  .next-delivery {
    flex-direction: row;
    align-items: center;
  }
}
@media (min-width: 768px) {
  .hero-actions {
    flex-direction: row;
  }
  .steps-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .benefit-grid {
    grid-template-columns: repeat(4, 1fr);
  }
  .market-banner div {
    padding: 2.5rem;
  }
}
@media (min-width: 992px) {
  .home-hero {
    padding: 5rem 0;
    min-height: 700px;
    display: flex;
    align-items: center;
  }
  .hero-visual {
    display: block;
  }
}
@media (min-width: 1200px) {
  .home-hero h1 {
    font-size: 5.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Home.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,SAAS;AACT;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,cAAc;EACd,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,OAAO;AACT;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6DAA6D;AAC/D;AACA;;EAEE,gBAAgB;EAChB,8BAA8B;EAC9B,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Page-specific styles for Home */\n\n/* Home */\n.home-hero {\n  position: relative;\n  overflow: hidden;\n  padding: 0.8rem 0;\n  color: white;\n  background: var(--green-950);\n}\n.home-hero::before {\n  content: \"\";\n  position: absolute;\n  width: 380px;\n  height: 380px;\n  left: -240px;\n  bottom: -180px;\n  border: 70px solid rgba(255, 255, 255, 0.04);\n  border-radius: 50%;\n}\n.mobile-location {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  margin-bottom: 2.5rem;\n  font-size: 0.8rem;\n}\n.mobile-location span {\n  flex: 1;\n}\n.mobile-location small,\n.mobile-location strong {\n  display: block;\n  line-height: 1.25;\n  font-size: 14px;\n}\n.mobile-location small {\n  color: rgba(255, 255, 255, 0.5);\n}\n.hero-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1.2rem;\n  padding: 0.55rem 0.8rem;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 50px;\n  color: #dcebe2;\n  background: rgba(255, 255, 255, 0.06);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n.home-hero h2 {\n  font-size: clamp(3.1rem, 8vw, 6rem);\n  line-height: 0.9;\n  margin: 0;\n}\n.home-hero h2 em {\n  color: var(--yellow);\n  font-weight: inherit;\n}\n.home-hero .col-lg-6 > p {\n  color: rgba(255, 255, 255, 0.68);\n  font-size: 1.1rem;\n  max-width: 560px;\n  margin: 1.5rem 0;\n}\n.hero-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.trust-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-top: 1.25rem;\n  color: rgba(255, 255, 255, 0.66);\n  font-size: 0.78rem;\n}\n.trust-row i {\n  color: #82c89c;\n}\n.hero-visual {\n  display: none;\n  position: relative;\n  max-width: 520px;\n  margin-left: auto;\n}\n.hero-visual > img {\n  width: 100%;\n  height: 550px;\n  object-fit: cover;\n  border-radius: 42% 42% 26px 26px;\n}\n.floating-card {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 220px;\n  padding: 0.9rem 1rem;\n  border-radius: 16px;\n  color: var(--ink);\n  background: rgba(255, 254, 250, 0.94);\n  box-shadow: var(--shadow);\n  backdrop-filter: blur(12px);\n}\n.floating-card.top {\n  top: 22%;\n  left: -14%;\n}\n.floating-card.bottom {\n  right: -5%;\n  bottom: 9%;\n}\n.floating-card > i {\n  width: 38px;\n  height: 38px;\n  display: grid;\n  place-items: center;\n  border-radius: 12px;\n  color: var(--green-800);\n  background: var(--green-100);\n}\n.floating-card small,\n.floating-card strong {\n  display: block;\n  font-size: 0.72rem;\n  line-height: 1.3;\n}\n.floating-card small {\n  color: var(--muted);\n}\n.service-card {\n  height: 100%;\n  min-height: 300px;\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: 1.25fr 0.75fr;\n  border-radius: var(--radius);\n  color: white;\n  text-decoration: none;\n  position: relative;\n}\n.service-card.shake {\n  background: #376c54;\n}\n.service-card.fruits {\n  background: #b85534;\n}\n.service-card > div {\n  z-index: 1;\n  padding: 1.7rem;\n  align-self: center;\n}\n.service-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  mask-image: linear-gradient(to right, transparent, black 32%);\n}\n.service-card h2,\n.service-card h3 {\n  margin: 0.5rem 0;\n  font-family: var(--font-serif);\n  font-size: clamp(1.6rem, 3vw, 2.4rem);\n  line-height: 1;\n}\n.service-card p {\n  color: rgba(255, 255, 255, 0.75);\n}\n.service-card .card-kicker {\n  color: rgba(255, 255, 255, 0.6);\n}\n.service-icon {\n  width: 48px;\n  height: 48px;\n  display: grid;\n  place-items: center;\n  border-radius: 14px;\n  color: var(--green-950);\n  background: var(--yellow);\n  font-size: 1.15rem;\n}\n.service-link {\n  font-size: 1.2rem;\n  font-weight: 800;\n}\n.service-link i {\n  margin-left: 0.35rem;\n  transition: transform 0.2s;\n}\n.service-card:hover .service-link i {\n  transform: translateX(4px);\n}\n.next-delivery {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1.25rem;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n  box-shadow: 0 8px 30px rgba(23, 49, 36, 0.05);\n}\n.date-tile {\n  width: 65px;\n  height: 72px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  color: white;\n  background: var(--green-800);\n}\n.date-tile strong {\n  font-family: var(--font-serif);\n  font-size: 1.8rem;\n  line-height: 1;\n}\n.date-tile span {\n  font-size: 0.65rem;\n  letter-spacing: 0.12em;\n}\n.next-delivery h3 {\n  font-family: var(--font-serif);\n  margin: 0 0 0.35rem;\n  font-size: 1.5rem;\n}\n.next-delivery p {\n  margin: 0;\n  color: var(--muted);\n  font-size: 0.9rem;\n}\n.how-section {\n  padding: 2rem 0;\n  background: #edf3ee;\n}\n.steps-grid {\n  display: grid;\n  gap: 1rem;\n}\n.step-card {\n  position: relative;\n  min-height: 245px;\n  padding: 1.5rem;\n  border: 1px solid #d7e4da;\n  border-radius: var(--radius);\n  background: rgba(255, 255, 255, 0.55);\n}\n.step-card > i {\n  width: 50px;\n  height: 50px;\n  display: grid;\n  place-items: center;\n  border-radius: 15px;\n  color: var(--green-700);\n  background: white;\n}\n.step-number {\n  position: absolute;\n  right: 1.4rem;\n  top: 1.1rem;\n  font-family: var(--font-serif);\n  color: #b6cabd;\n  font-size: 2.2rem;\n}\n.step-card h3 {\n  margin-top: 2rem;\n  font-family: var(--font-serif);\n  font-size: 1.5rem;\n}\n.step-card p {\n  color: var(--muted);\n}\n.freshness-banner {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  padding: 1.25rem;\n  border-radius: var(--radius);\n  color: white;\n  background: var(--green-950);\n}\n.freshness-banner > i {\n  color: var(--yellow);\n  font-size: 1.4rem;\n}\n.freshness-banner p {\n  margin: 0.25rem 0 0;\n  color: rgba(255, 255, 255, 0.65);\n}\n.benefit-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem;\n}\n.benefit-grid div {\n  min-height: 120px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  background: var(--paper);\n  font-weight: 700;\n}\n.benefit-grid i {\n  color: var(--green-700);\n  font-size: 1.3rem;\n}\n\n@media (min-width: 576px) {\n  .next-delivery {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n@media (min-width: 768px) {\n  .hero-actions {\n    flex-direction: row;\n  }\n  .steps-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .benefit-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  .market-banner div {\n    padding: 2.5rem;\n  }\n}\n@media (min-width: 992px) {\n  .home-hero {\n    padding: 5rem 0;\n    min-height: 700px;\n    display: flex;\n    align-items: center;\n  }\n  .hero-visual {\n    display: block;\n  }\n}\n@media (min-width: 1200px) {\n  .home-hero h1 {\n    font-size: 5.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
